import clsx from 'clsx'
import Link from 'next/link'
import type { FC, ReactNode } from 'react'

import styles from './index.module.scss'

export type NavItemProps = {
  className?: string
  path?: string
  label?: ReactNode
  active?: boolean
  hidden?: boolean
  isDivider?: boolean
}

export const NavItem: FC<NavItemProps> = ({
  className,
  path,
  label,
  active = false,
  isDivider = false,
  hidden = false,
}) => {
  if (hidden) return null

  if (isDivider) return <div className="h-20 w-1" />

  if (!path) return null

  return (
    <Link
      href={path}
      target={path.startsWith('http') ? '_blank' : '_self'}
      className={clsx(
        'relative p-12 text-body-m text-text-color-subdued',
        className,
        {
          // @ts-ignore
          [styles.active]: active,
        },
      )}
    >
      {label}
    </Link>
  )
}
